/* eslint-disable no-prototype-builtins */

import React from 'react'
import { Col, Progress, Row } from 'antd'
import styles from './percentage-progress-card.module.scss'
import { useTranslation } from 'react-i18next'

const PercentageProgressCard = ({ studentData }) => {
  const i18n = useTranslation()
  const studentSurveyTotalData = studentData && studentData.surveyTotalData
  const studentTotalAnswers = studentData && studentData.totalAnswers

  if (!studentTotalAnswers) return null
  const check = studentTotalAnswers.hasOwnProperty('enivel')
  const calculateLevelProgress = answer => {
    if (check) {
      return Math.round(
        (studentTotalAnswers?.enivel[answer] / studentSurveyTotalData?.settings?.enivel[answer]?.min) * 100
      )
    }
    return 0
  }

  const calculateTotalprogress = Math.round(
    (studentTotalAnswers?.total / studentSurveyTotalData?.settings.min) * 100
  )

  return (
    <Col className={styles.container}>
      <p className={styles.title}>{i18n.t('data.progress-card.title')}</p>
      <Row className={styles.progress_status_bar_wrapper}>
        <Col className={styles.progress_status_bar}>
          <h6>4º</h6>
          <Progress
            percent={calculateLevelProgress('AO01') || 0}
            strokeColor='#17BEBB'
          />
        </Col>
        <Col className={styles.progress_status_bar}>
          <h6>5º</h6>
          <Progress
            percent={calculateLevelProgress('AO02') || 0}
            strokeColor='#17BEBB'
          />
        </Col>
        <Col className={styles.progress_status_bar}>
          <h6>6º</h6>
          <Progress
            percent={calculateLevelProgress('AO03') || 0}
            strokeColor='#17BEBB'
          />
        </Col>
        <Col className={styles.progress_status_bar}>
          <h6>7º</h6>
          <Progress
            percent={calculateLevelProgress('AO04') || 0}
            strokeColor='#17BEBB'
          />
        </Col>
        <Col className={styles.progress_status_bar}>
          <h6>8º</h6>
          <Progress
            percent={calculateLevelProgress('AO05') || 0}
            strokeColor='#17BEBB'
          />
        </Col>
        <Col className={styles.progress_status_bar}>
          <h6>Iº</h6>
          <Progress
            percent={calculateLevelProgress('AO06') || 0}
            strokeColor='#17BEBB'
          />
        </Col>
        <Col className={styles.progress_status_bar}>
          <h6>IIº</h6>
          <Progress
            percent={calculateLevelProgress('AO07') || 0}
            strokeColor='#17BEBB'
          />
        </Col>
        <Col className={styles.progress_status_bar}>
          <h6>IIIº</h6>
          <Progress
            percent={calculateLevelProgress('AO08') || 0}
            strokeColor='#17BEBB'
          />
        </Col>
        <Col className={styles.progress_status_bar}>
          <h6>IVº</h6>
          <Progress
            percent={calculateLevelProgress('AO09') || 0}
            strokeColor='#17BEBB'
          />
        </Col>
        <Col className={styles.progress_status_bar}>
          <h6>T</h6>
          <Progress
            percent={calculateTotalprogress}
            strokeColor='#6441A5'
          />
        </Col>
      </Row>
    </Col>
  )
}

export default PercentageProgressCard
